import MyProfile from 'views/myProfile.js';
import TableList from 'views/liste darrivée/TableList';
import Reservations from 'views/réunion/Reservations.js';
import Conciergerie from 'views/conciergerie/Conciergerie.js';
import Colis from './views/colis/Colis.js';
import Home from './views/Home';
import Events from './views/Event/Event.js';
import EventSport from './views/Event/EventSport';
import EventBeautyRoom from 'views/Event/EventBeautyRoom.js';
import CydWebview from 'views/webview/cyd.js';
import FoodlesWebview from 'views/webview/foodles.js';
import Place from 'views/place/place.js';
import axios from './components/Axios/Axios.js';
import DNS from './components/DNS/dns.js';

let dashboardRoutes = [
  {
    path: '/home',
    name: 'Accueil',
    icon: 'nc-icon nc-grid-45',
    component: Home,
    layout: '/resident',
  },
  {
    path: '/table',
    name: 'Liste de Rendez Vous',
    icon: 'nc-icon nc-notes',
    component: TableList,
    layout: '/resident',
  },
  {
    path: '/Reservations',
    name: 'mes réunions',
    icon: 'nc-icon nc-watch-time',
    component: Reservations,
    layout: '/resident',
  },
  {
    path: '/Conciergerie',
    name: 'Conciergerie',
    icon: 'nc-icon nc-icon nc-tablet-2',
    component: Conciergerie,
    layout: '/resident',
  },
  {
    path: '/Colis',
    name: 'Colis',
    icon: 'nc-icon nc-backpack',
    component: Colis,
    layout: '/resident',
  },
  {
    path: '/Events',
    name: 'Évènements',
    icon: 'nc-icon nc-album-2',
    component: Events,
    layout: '/resident',
  },
  {
    path: '/EventSport',
    name: 'Salle de Sport',
    icon: 'nc-icon nc-album-2',
    component: EventSport,
    layout: '/resident',
  },
  {
    path: '/EventBeautyRoom',
    name: 'Beauty Room',
    icon: 'nc-icon nc-album-2',
    component: EventBeautyRoom,
    layout: '/resident',
  },
  {
    path: '/profile',
    name: 'Mon Profil',
    icon: 'nc-icon nc-circle-09',
    component: MyProfile,
    layout: '/resident',
  },
  {
    path: '/place',
    name: 'Place de Parking',
    icon: 'nc-icon nc-circle-09',
    component: Place,
    layout: '/resident',
  },
  {
    path: '/Foodles',
    name: 'Foodles',
    icon: 'nc-icon nc-atom',
    component: FoodlesWebview,
    layout: '/resident',
  },
  {
    path: '/Cyd',
    name: 'Cyd',
    icon: 'nc-icon nc-atom',
    component: CydWebview,
    layout: '/resident',
  },
];

/**
 * This function check and return all the pages that the site have access.
 * @function getAllTrueOption
 * @param {any} tokenUser tokenUser.
 * @param {any} pkBuilding pkBuilding.
 * @param {any} role role.
 * @return {Array} the AREA.
*/
function getAllTrueOption(tokenUser, pkBuilding, role) {
  const requestOptionsAxiosHeaders = {
    headers: {'Content-Type': 'application/json', 'Authorization': 'token ' + tokenUser},
  };
  return (axios.get(DNS + '/area/crudArea/' + pkBuilding + '/', requestOptionsAxiosHeaders)
      .then((response) => {
        const Area = response.data.fields;
        Area.map((elem) => {
          let lenghtArea = dashboardRoutes.length;
          for (let i = 0; i < lenghtArea; i++) {
            if (elem.accueil == false && dashboardRoutes[i].name == 'Accueil') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.profile == false && dashboardRoutes[i].name == 'Profile') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.liste_de_rdv == false && dashboardRoutes[i].name == 'Liste de Rendez Vous') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.réservation == false && dashboardRoutes[i].name == 'Réservation') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.main_courante == false && dashboardRoutes[i].name == 'Main Courante') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.badge == false && dashboardRoutes[i].name == 'Badge') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.place == false && dashboardRoutes[i].name == 'Place') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.documents == false && dashboardRoutes[i].name == 'Documents') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.conciergerie == false && dashboardRoutes[i].name == 'Conciergerie') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.colis == false && dashboardRoutes[i].name == 'Colis/Plis/Courrier') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.évènement == false && dashboardRoutes[i].name == 'Évènements') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.foodles == false && dashboardRoutes[i].name == 'Foodles') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (elem.cyd == false && dashboardRoutes[i].name == 'Cyd') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (
              elem.salle_de_sport == false && dashboardRoutes[i].name == 'Salle de Sport') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
            if (
              elem.beautyRoom == false && dashboardRoutes[i].name == 'Beauty Room') {
              dashboardRoutes.splice(i, 1);
              lenghtArea -= 1;
              i -= 1;
            }
          }
          return (dashboardRoutes);
        });
        return dashboardRoutes;
      }));
}

/**
 * This function check and return all the pages that the site have access async.
 * @function routesFunction
 * @param {any} tokenUser tokenUser.
 * @param {any} pkBuilding pkBuilding.
 * @param {any} role role.
 * @return {Array} the AREA.
*/
export async function routesFunction(tokenUser, pkBuilding, role) {
  const data = await getAllTrueOption(tokenUser, pkBuilding, role);
  dashboardRoutes = data;
  return data;
}

export default dashboardRoutes;
